(ns common.schema.decision-types
  (:require
   [clojure.set :as set]))

(def decision-entity-types
  #{:entity.type/ic-decision
    :entity.type/aifm-decision
    :entity.type/advisory-board-decision
    :entity.type/pm-approval-decision
    :entity.type/one-pager-decision
    :entity.type/icm-decision
    :entity.type/scm-decision
    ;; exit-oppos:
    :entity.type/ic-exit-decision
    :entity.type/aifm-exit-decision})

(def decision-associated-entity-types
  #{:entity.type/decision-condition
    :entity.type/decision-participant
    :entity.type/investment-reservation
    :entity.type/investment-reservation-type})

(def decision-or-associated-entity-types
  (set/union decision-entity-types decision-associated-entity-types))

(defn decision-entity-type?
  [entity-type]
  (contains? decision-entity-types entity-type))

(defn decision-or-associated-entity-type?
  [entity-type]
  (contains? decision-or-associated-entity-types entity-type))
